import { apm } from '@elastic/apm-rum';

export class FileeeLogAppender {
  debug(logger, message, ...rest) {
    console.debug(`[JS] DEBUG ` + this.getTime() + ` [${logger.id}] ${message}`, ...rest);
  }
  info(logger, message, ...rest) {
    console.info(`[JS] INFO ` + this.getTime() + ` [${logger.id}] ${message}`, ...rest);
  }
  warn(logger, message, ...rest) {
    console.warn(`[JS] WARN ` + this.getTime() + ` [${logger.id}] ${message}`, ...rest);
    this.captureApmError(logger, message, rest);
  }
  error(logger, message, ...rest) {
    console.error(`[JS] ERROR ` + this.getTime() + ` [${logger.id}] ${message}`, ...rest);
    this.captureApmError(logger, message, rest);
  }
  critical(logger, message, ...rest) {
    console.error(`[JS] ERROR ` + this.getTime() + ` [${logger.id}] ${message}`, ...rest);
    this.captureApmError(logger, message, rest);
  }

  /**
   * Reports to Elastic APM. Prefers a real Error object (for a symbolicated
   * stacktrace); falls back to the plain message. Never include a timestamp in
   * the message — it breaks error grouping in Kibana.
   */
  captureApmError(logger, message, rest) {
    const error = this.getError(message, rest);
    if (error) {
      apm.captureError(error);
    } else {
      apm.captureError(`[JS] [${logger.id}] ${message}`);
    }
  }

  getError(message, rest) {
    if (message instanceof Error) {
      return message;
    } else {
      let filteredArray = rest.filter((x) => x instanceof Error);
      return filteredArray.length > 0 ? filteredArray[0] : undefined;
    }
  }

  getTime() {
    let currentdate = new Date();
    let minutes = currentdate.getMinutes();
    let seconds = currentdate.getSeconds();
    return (
      currentdate.getHours() +
      ':' +
      (minutes < 10 ? '0' + minutes : minutes) +
      ':' +
      (seconds < 10 ? '0' + seconds : seconds)
    );
  }
}
